const headRowsSupport = {
  file: 'File',
  updatedAt: 'Modified in',
  size: 'Size',
  download: 'Download',
  description: 'Description',
  type: 'Visibility',
  admin: 'Edit'
};

export default headRowsSupport;
